module.exports = "/_next/static/images/logo-dark-blue-fd4a2bb6a262d2a795a1c2315801c5bc.svg";